import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ServerIndex } from '../../Servers/router/screens/Index';

const ServerRoutes = (
  <Route
    path="/dashboard"
    render={() => (
      <Switch>
        <Route path="/dashboard" component={ServerIndex} />
      </Switch>
    )}
  />
);

export { ServerRoutes };
